import Link from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { FORGOT_PASSWORD } from '../../brands/default/content/components/login';
import { LINK_FORGOT_PASSWORD } from '../../brands/default/links';
import { redirectToURL } from '../../helpers/url';
import ThemeContext from '../../providers/ThemeProvider';

const ForgotPassword = ({ email, isFBOnly }) => {
  const theme = useContext(ThemeContext);
  const router = useRouter();

  const { createPassword, forgotYourPassword } = FORGOT_PASSWORD;

  const getLink = (event) => {
    event.preventDefault();
    if (email) {
      const redirectURL = `${LINK_FORGOT_PASSWORD}?email=${email}`;
      redirectToURL(redirectURL, router);

      return;
    }
    redirectToURL(LINK_FORGOT_PASSWORD, router);
  };

  return (
    <>
      <p className="text-right">
        <em>
          <Link href="#">
            <a onClick={getLink} onKeyDown={getLink} role="link" tabIndex={0}>
              {isFBOnly ? createPassword : forgotYourPassword}
            </a>
          </Link>
        </em>
      </p>
      <style jsx>{`
        .text-right a {
          color: ${theme.colors.primary};
        }
      `}</style>
    </>
  );
};

ForgotPassword.propTypes = {
  email: PropTypes.string,
  isFBOnly: PropTypes.bool,
};

ForgotPassword.defaultProps = {
  email: '',
  isFBOnly: false,
};

export default ForgotPassword;
